// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Box } from '@iheartjane/reefer';

export const Tile = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.grays.ultralight,
  display: 'flex',
  flexDirection: 'column',
}));
